__turbopack_context__.v({
  "articleContainer": "lcResourcesArticles-module-scss-module__PsTshW__articleContainer",
  "moreArticle": "lcResourcesArticles-module-scss-module__PsTshW__moreArticle",
  "title": "lcResourcesArticles-module-scss-module__PsTshW__title",
});
